import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/layout'
import index from '@/pages/newHome'
// import newHome from '@/pages/newHome'
const news = () => import('@/pages/news')
const newsDetail = () => import('@/pages/newsDetail')
const registerOrg = () => import('@/pages/registerOrg')
const registerPlanner = () => import('@/pages/registerPlanner')
const login = () => import('@/pages/login')
const forget = () => import('@/pages/forget')
const planner = () => import('@/layout/planner')
// const plannerHome = () => import('@/layout/plannerHome')
const plannerIssueList = () => import('@/pages/plannerIssueList')
// const plannerQA = () => import('@/layout/plannerQA')
const plannerQAList = () => import('@/pages/plannerQAList')
// const user = () => import('@/pages/user')
const message = () => import('@/pages/message')
const personInfo = () => import('@/pages/personInfo')
const issueDetail = () => import('@/pages/issueDetail')
const issueQa = () => import('@/pages/issueQa')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      redirect: '/index',
      children: [
        {
          path: 'index',
          component: index,
          name: 'index'
        },
        {
          path: 'news/:blockId',
          name: 'news',
          component: news
        },
        {
          path: 'newsDetail/:id',
          name: 'newsDetail',
          component: newsDetail
        },
        {
          path: 'planner',
          name: 'planner',
          component: planner,
          meta: {
            requireAuth: true
          },
          redirect: {
            name: 'plannerIssueList'
          },
          children: [
            {
              // path: 'plannerHome',
              // name: 'plannerHome',
              // component: plannerHome,
              // redirect: {
              //   name: 'plannerIssueList'
              // },
              // children: [
              //   {
                  path: 'plannerIssueList',
                  name: 'plannerIssueList',
                  component: plannerIssueList
                },
                {
                  path: 'issueDetail/:id',
                  name: 'issueDetail',
                  component: issueDetail
                // }
              // ]
            },
            {
              // path: 'plannerQA',
              // name: 'plannerQA',
              // component: plannerQA,
              // redirect: {
              //   name: 'plannerQAList'
              // },
              // children: [
              //   {
                  path: 'plannerQAList',
                  name: 'plannerQAList',
                  component: plannerQAList
                },
                {
                  path: 'issueQa/:id',
                  name: 'issueQa',
                  component: issueQa
              //   }
              // ]
            },
            {
              // path: 'user',
              // name: 'user',
              // component: user,
              // redirect: {
              //   name: 'message'
              // },
              // children: [
              //   {
                  path: 'message',
                  name: 'message',
                  component: message
                },
                {
                  path: 'personInfo',
                  name: 'personInfo',
                  component: personInfo
              //   }
              // ]
            }
          ]
        }
      ]
    },
    {
      path: '/registerOrg',
      name: 'registerOrg',
      component: registerOrg
    },
    {
      path: '/registerPlanner',
      name: 'registerPlanner',
      component: registerPlanner
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget
    }
  ],
  mode: 'hash'
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (!window.localStorage.getItem('token_token')) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js